// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1mZkF","row":"styles_row__36947"};